import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DEFAULT_TITLE = "DadaDeLuxe | Luxury Wig Installs & Sew-Ins";
const DEFAULT_DESCRIPTION =
  "DadaDeLuxe - Luxury wig installs, sew-ins, quickweaves, and elevated styling in West Philadelphia.";
const DEFAULT_IMAGE_PATH = "/images/home-hero.jpg";

const PAGE_META = {
  "/": {
    title: "DadaDeLuxe | Luxury Wig Installs & Sew-Ins",
    description:
      "Luxury wig installs, sew-ins, quickweaves, and premium styling services. Book your appointment with DadaDeLuxe.",
  },
  "/services": {
    title: "Services | DadaDeLuxe",
    description:
      "Explore DadaDeLuxe service packages, pricing, and detailed descriptions for luxury installs and styling.",
  },
  "/gallery": {
    title: "Gallery | DadaDeLuxe",
    description:
      "View the DadaDeLuxe hairstyle gallery featuring wig installs, sew-ins, quickweaves, and ponytail looks.",
  },
  "/about": {
    title: "Meet The Stylist | DadaDeLuxe",
    description:
      "Meet Adama, the stylist behind DadaDeLuxe, and learn about her luxury hair artistry and experience.",
  },
  "/policies": {
    title: "Salon Policies | DadaDeLuxe",
    description:
      "Read DadaDeLuxe salon policies, booking requirements, deposits, cancellation terms, and preparation details.",
  },
  "/contact": {
    title: "Contact | DadaDeLuxe",
    description:
      "Get in touch with DadaDeLuxe for booking support, service questions, and appointment assistance.",
  },
  "/book": {
    title: "Book Appointment | DadaDeLuxe",
    description:
      "Book your DadaDeLuxe appointment online. Select your service, choose add-ons, and secure your date and time.",
  },
  "/booking-confirmation": {
    title: "Booking Confirmed | DadaDeLuxe",
    description:
      "Your DadaDeLuxe booking is confirmed. Review your appointment details and next steps.",
    noindex: true,
  },
  "/admin": {
    title: "Sign In | DadaDeLuxe",
    description: "Secure sign-in for DadaDeLuxe management.",
    noindex: true,
  },
  "/admin/dashboard": {
    title: "Dashboard | DadaDeLuxe",
    description: "DadaDeLuxe scheduling and client management dashboard.",
    noindex: true,
  },
};

function upsertMetaByName(name, content) {
  let tag = document.head.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function upsertMetaByProperty(property, content) {
  let tag = document.head.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("property", property);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function upsertCanonical(href) {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

export default function SeoManager() {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname || "/";
    const pageMeta = PAGE_META[pathname] || PAGE_META["/"];
    const title = pageMeta.title || DEFAULT_TITLE;
    const description = pageMeta.description || DEFAULT_DESCRIPTION;
    const origin = window.location.origin || "";
    const canonicalUrl = `${origin}${pathname}`;
    const socialImage = `${origin}${DEFAULT_IMAGE_PATH}`;
    const robots = pageMeta.noindex ? "noindex, nofollow" : "index, follow";

    document.title = title;
    upsertMetaByName("description", description);
    upsertMetaByName("robots", robots);
    upsertCanonical(canonicalUrl);

    upsertMetaByProperty("og:type", "website");
    upsertMetaByProperty("og:site_name", "DadaDeLuxe");
    upsertMetaByProperty("og:title", title);
    upsertMetaByProperty("og:description", description);
    upsertMetaByProperty("og:url", canonicalUrl);
    upsertMetaByProperty("og:image", socialImage);

    upsertMetaByName("twitter:card", "summary_large_image");
    upsertMetaByName("twitter:title", title);
    upsertMetaByName("twitter:description", description);
    upsertMetaByName("twitter:image", socialImage);
  }, [location.pathname]);

  return null;
}
